import { Action } from '@ngrx/store';
import { AcompananteData } from '../models/store.model';


export const SETACOMPANANTEDATA = '[AcompananteData] Set Data';
export const UNSETACOMPANANTEDATA = '[AcompananteData] Unset Data';

export class SetAcompananteData implements Action {
    readonly type = SETACOMPANANTEDATA;
    constructor(public acompanante: AcompananteData) { }
}

export class UnsetAcompananteData implements Action {
    readonly type = UNSETACOMPANANTEDATA;
}

export type AcompananteDataActions =
    | SetAcompananteData
    | UnsetAcompananteData;
